// extracted by mini-css-extract-plugin
export var cardTitle = "_i7-1";
export var commentBubble = "_i7-e";
export var commentForm = "_i7-a";
export var commentInput = "_i7-b";
export var commentLabel = "_i7-d";
export var commentPrompt = "_i7-9";
export var csatCard = "_i7-0";
export var feedbackSection = "_i7-7";
export var starDisabled = "_i7-6";
export var starEmpty = "_i7-5";
export var starFilled = "_i7-4";
export var starWrapper = "_i7-3";
export var starsContainer = "_i7-2";
export var submittedComment = "_i7-c";
export var thankYouText = "_i7-8";